import { useState } from "react";
import { useGlobalSettings } from "../../hooks/useGlobalSettings";

const ZALO_QR_URL =
  "https://storage.readdy-site.link/project_files/5f2724b2-0dd8-4526-ab2c-c1f8f3f4c6d1/f082dae8-7226-4b2d-b991-d20161c43010_z7779119611048_cb348e7a366b2e389a04c04baa7ae51a.jpg?v=d8fd06d0378882651782d76be8386640";

interface ZaloLinkProps {
  children: React.ReactNode;
  className?: string;
  tooltipPosition?: "top" | "bottom" | "left" | "right";
  title?: string;
  url?: string;
}

export const ZaloLink = ({
  children,
  className = "",
  tooltipPosition = "top",
  title,
  url,
}: ZaloLinkProps) => {
  const [show, setShow] = useState(false);
  const { settings } = useGlobalSettings();
  const zaloUrl = url?.trim() || settings.zalo_url;

  const positionClasses: Record<string, string> = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  const arrowClasses: Record<string, string> = {
    top: "top-full left-1/2 -translate-x-1/2 -mt-1 rotate-45 border-r border-b",
    bottom:
      "bottom-full left-1/2 -translate-x-1/2 -mb-1 rotate-45 border-l border-t",
    left: "left-full top-1/2 -translate-y-1/2 -ml-1 rotate-45 border-r border-t",
    right:
      "right-full top-1/2 -translate-y-1/2 -mr-1 rotate-45 border-l border-b",
  };

  return (
    <a
      href={zaloUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`relative ${className}`}
      title={title}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {/* Tooltip QR — chỉ hiện trên desktop */}
      <div
        className={`absolute z-[60] ${positionClasses[tooltipPosition]} hidden md:block transition-all duration-200 ${show ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-95 pointer-events-none"}`}
      >
        <div
          className="bg-white rounded-xl p-3 border border-gray-200"
          style={{ boxShadow: "0 10px 40px rgba(0,0,0,0.15)" }}
        >
          <p className="text-xs font-semibold text-gray-700 text-center mb-2 whitespace-nowrap">
            Quét mã để chat Zalo
          </p>
          <img
            src={ZALO_QR_URL}
            alt="QR Zalo Bizwell"
            className="w-40 h-40 object-contain rounded-lg"
          />
          <p className="text-[10px] text-gray-400 text-center mt-2">
            0965 180 170
          </p>
        </div>
        {/* Arrow */}
        <div
          className={`absolute w-2 h-2 bg-white border-gray-200 ${arrowClasses[tooltipPosition]}`}
        />
      </div>
    </a>
  );
};

export default ZaloLink;